export const SET_DIDS = "SET_DIDS";
export const ADD_DID_TO_LIST = "ADD_DID_TO_LIST";
export const SET_DID = "SET_DID";
export const ADD_NEW_DID = "ADD_NEW_DID";
export const CLEAR_DID = "CLEAR_DID";
